<template>
	<div class="search-detail-app">
		<div class="search-detail">
			<div class="search-detail-left">
				<div class="detail-nav">
					<router-link to="/">
						<img src="images/list.png" />题库
					</router-link>
					<!-- <span style="font-size:18px">{{searchDetail.title}}</span>
					{{searchDetail.id}} -->
					

				</div>
				<div  class="title-text"   v-if="text !== ''">
						{{searchDetail.text}}
				</div>
				<dl>	
					<em> {{searchDetail.genre_text}}</em>
					<dt  v-html="searchDetail.title" ></dt>

					<div class="demo-image__preview" v-if="searchDetail.icon"  > 
							<el-image style="width: 100%; height: 100%" :src="searchDetaile"> 
								</el-image>
						</div>
					<dd  class="textons"  v-for="(item,index) in searchDetail.option_name" :key="index">
						{{index}} 
						<span v-if="item.indexOf('http')==-1" >{{item}}</span>
						<img :src="item"  referrerpolicy="no-referrer" alt="">
					</dd>
					<p v-if="searchDetail.answer !==''"  :class="{titefont:AnswerFont}"              class="sears">正确答案： <span class="sear"    :class="{AnswerFontcs:AnswerFont}" >{{searchDetail.answer}}</span></p>
				</dl>
				<div class="search-parsing">
					<i> <div style="margin: 0 5px 0 0;"  class="parsing-red"  ></div>  莘知解析：</i>
					<span v-html="searchDetail.analysis">{{searchDetail.analysis}}</span>

				</div>
						<p style="margin-top:30px;color:black; "><span style="    display: inline-block; width: 5px; height: 15px;margin: 0px 8px 0px 27px;border-radius: 2px 2px 2px 2px; background-color: red;"></span><span style="font-size: 18px;font-family: Microsoft YaHei;font-weight: bold;color: #0c0101;">试题来源:</span>  {{searchDetail.source_name}}</p>


				
			
			</div>
			
			
			
			
			
			
			
			
			
			
			<!-- <div class="search-detail-right">
				<div class="search-right-news">
					<h3>
						莘知课程
						<a @click="openMoreLesson">更多</a>
					</h3>
					<p>
						<img src="/images/a4.png" alt />
					</p>
					<ol>
						<li
							v-for="(item,index) in detailData.lesson"
							:key="index"
							@click="openLesson(item.id)"
							:data-id="index+1"
						>{{item.name}}</li>
					</ol>
				</div>

				<div class="search-right-book">
					<h3>莘知图书</h3>
					<el-carousel trigger="click" height="180px" indicator-position="none">
						<el-carousel-item v-for="item in detailData.book" :key="item.id">
							<p @click="openBook(item.id)">
								<img :src="szUrl+item.icon" alt />
							</p>
						</el-carousel-item>
					</el-carousel>
				</div>

				<div class="search-right-bottom">
					<h3>莘知网校</h3>
					<a v-for="item in detailData.course" :key="item.id" @click="openCourse(item.id)">{{item.name}}</a>
				</div> -->
			</div>
				<div class="answer-note"   >
						<div class="parsing-title"> <span class="parsing-red"></span> 本题笔记</div>
						<aside >
					
								<el-input     type="textarea" v-model="noteValue" maxlength="2000" rows="5"
								 show-word-limit >
								</el-input>
						
						
						</aside>
							<el-button type="primary" size="small" @click="addnote()">提交</el-button>
						<div class="answer-note-list" v-if="notes!==''">
							<div class="note-list" v-for="(vv,kk) in notes" :key="vv.id">
								<div class="note-list-tit">
									<div class="note-list-photo">
										<el-avatar :size="50" :src="vv.image"></el-avatar>
									</div>
									<div class="note-list-info">
										<div>
												<sapn  class="note-list-in"    style="margin-top:4px">{{vv.nickname}}</sapn>
											<sapn  class="note-list-ins"    >{{vv.create_time}}</sapn>
										</div>
										<div style="text-align: right">
													
											
												<button   :class="{ sun:vv.on_praise == 1 }"          class="note-list-praise" @click="praiseNote($event,vv.id)">{{vv.praise }}</button>
													<button   v-show='vv.user_id ==userid '   class="note-list-dete" title="删除"
												@click="deleteNote(vv.id)">删除</button>

										</div>

									
									</div>
								
									<!-- <button  class="note-list-praise"
										@click="praiseNote($event,vv.id)">{{vv.praise}}</button> -->
								</div>
								<div class="note-list-text"><pre>{{vv.content}}</pre> </div>
							</div>
							
						</div>
							<div  class="notite" v-else>
							暂无笔记
							</div>
					</div>
						<el-dialog :visible.sync="showLogin" :append-to-body="true" :show-close="false" width="400px"
						v-if="showLogin" :close-on-click-modal="false">
						<Login :loginType="loginType" v-on:listenLogin="listenLogin"    @show="onlin"></Login>
					</el-dialog>



		</div>

</template>

<script>
import Login from "@/components/Login.vue";
export default {
		components:{Login},
		name: "search-detail-app",
		data() {
			return {
				noteValue:'',
				searchDetail: [],
				optionA: ["A", "B", "C", "D", "E", "F", "G"],
				detailData: [],
				notes:'',
				sub_id:'',
				userid:'',
				Num:0,
				AnswerFont:false,
				text:'',
				searchDetaile:'',
				showLogin:'',
				loginType:'',

			};
		},
				watch: { // 监视latex的变化
          searchDetail() {
            this.$nextTick(function () { // Vue的DOM渲染是异步的
              if (MathJax.isMathjaxConfig) { // 是否配置MathJax
                  MathJax.initMathjaxConfig()
              }
             this.MathJax.MathQueue('search-detail-app') // 渲染对应的id/class
            })
          }
        },
		methods: {
			getSearchDetail(id_) {
		
				this.$loading();
				//console.log(id_)
				var param = {
					id:id_,
				};
				// this.$post("searchDetail", param).then((res) => {
				// 	this.searchDetail = res.data;
				// });
				this.$api.getSearchAnswer(param).then(res => {
					//console.log(res)
					this.searchDetail = res.data;
					this.	searchDetaile =res.data.icon
						if(this.searchDetail.genre_text=='简答题'){
				 this.AnswerFont= true
			}
				})
				setTimeout(() => {
					this.$loading().close();
				}, 500);
			},
				onlin(show){
				//console.log(show)
				this.showLogin =show},
			//删除笔记
				listenLogin(item) {
				this.loginType = item;},
			deleteNote(id_){
							this.$confirm('您确定要删除笔记吗？?', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }) .then(() => {
						this.$api.delUserNote({id:id_})
						.then((res)=>{
						  
						})
						this.$router.go(0)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
			},
			// getSzData() {
			// 	this.$post("searchBookCourseLesson").then((res) => {
			// 		this.detailData = res.data;
			// 	});
			// },
			openMoreLesson() {
				window.open(this.szUrl + "lesson", "_blank");
			},
			openLesson(id) {
				window.open(this.szUrl + "lesson/info/id/" + id, "_blank");
			},
			openBook(id) {
				window.open(this.szUrl + "tsxq/" + id, "_blank");
			},
			openCourse(id) {
				window.open(this.szUrl + "wkxq/" + id, "_blank");
			},
			getuserid(){
				this.userid=localStorage.getItem("userId")
			},
			praiseNote(e,id){
					if(localStorage.getItem('UserToken') =='' || localStorage.getItem('UserToken') ==null ){
					this.loginType = 'login'
					this.showLogin = true
					//console.log(this)
					this.$message.error('请先登录')
							return 
				}
	
					this.$api.userNotePraise({id:id}).then((res)=>{
								this.getxem( )
					})
			},

			//保存笔记
			addnote() {
				if(localStorage.getItem('UserToken') =='' || localStorage.getItem('UserToken') ==null ){
					this.loginType = 'login'
					this.showLogin = true
					//console.log(this)
					this.$message.error('请先登录')
							return 
				}
				


				//console.log("进入")
				if (this.noteValue == "") {
					this.$message({
						type: "error",
						message: "笔记不能为空！",
						showClose: true,
					});
					return;
				}
				this.$api.setUserNote({
					list_id: this.sub_id,
					sub_id: '',
					content: this.noteValue,
					type:2
				}).then((res) => {
					// //console.log(res);
					this.$message.success('笔记添加成功')
					this.noteValue = "";
					this.$router.go(0)
				});
			},
			// 获取获取
			getxem(){
			
					//console.log(this.$route.query.id)
					this.$api.getPageNote({list_id:this.$route.query.id }).then((res)=>{
					//console.log(res)
					this.notes = res.data
					this.text = res.data.text
						for ( let v of res.data) {
						 		 let  sum =  parseInt(v.content.replace(/\s*/g,"").length / 57)
								 let  number   = v.content.indexOf("\n")
								 //console.log(number)
								if(v.content.length >57){
											if(number!=-1){
												return
											}		
											for(let i = 1;i<=sum;i++){
											   let  nm=  v.content.slice(0,57*i)+'\n'+v.content.slice(57*i)
												 v.content = nm
											}
								    }
					   }
			   })
			}
		
		},
		mounted(){
				
		},
		created(){
			this.sub_id = this.$route.query.id
			this.getSearchDetail(this.$route.query.id);
			//console.log(this.$route.query.id)
			this.getuserid()
			this.getxem( )
		
			// id
		
			// this.getSzData();
		},
			
	};
</script>

<style scoped>

.notite{
	padding: 30px 45%;
	font-size:  18px;
	font-weight: 500;
}
	.search-detail {
		display: flex;
		overflow: hidden;
		/* margin-top: 20px; */
	}
	.search-detail-left {
		width: 1200px;
		flex: 1;
		background-color: #fff;
	}

	.title-text{
		color: #111111;
		padding: 20px 40px;
		font-size: 16px;
	}
	.search-detail-right {
		width: 280px;
		margin-left: 20px;
		background-color: #fff;
	}
	/deep/.el-button--small{
		padding: 11px 15px;
    font-size: 13px;
		
    border-radius: 3px;
		margin: 12px 0 0  37px;
		width: 80px;
   height: 36px;
   border-radius: 5px;
		font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #FFFFFF;



	

	}
	.sun {
		color: #ec1212 !important;
	}
	.textons{color: #111111 !important ;
		line-height: 48px;
	}

	.titefont{
		margin-top: 91px !important;
	}
	.sear{

font-size: 24px;
font-family: Microsoft YaHei;
font-weight: 400;
width: 950px;
color: #ec1212;
display: inline-block;


	}
	.AnswerFontcs{
		font-size: 17px !important;
	}
	.sears{

	font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #111111 !important;
	display: flex;
	margin-bottom: 20px;
	}
	 /deep/.el-input__count{
		bottom: -31px!important ;
    right: -4px !important;
			background-color: #F7F7F7  !important;

	}
	.search-detail-left dl {
		padding: 30px 60px 20px 110px;
		border-bottom: 1px dashed #ebebeb;
		position: relative;
	}
	.search-detail-left dt {


	width: 672px;

font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #111111;	

	
		margin-bottom: 20px;
	}
	.search-detail-left dd {
	
	
	margin: 10px 0 0 0;
		color: #999;
	}
	.search-detail-left dd span {
		width: 96px;
		height: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		
		
		margin-left: 10px;
		
	}
	.parsing-title{background: none !important;

font-size: 18px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #333333;
	margin: 10px 10px;
	
	}
	.parsing-title span{
		margin:  0 10px  0 18px!important;
	}
	.search-detail-left p {
		font-size: 16px;
		margin-top: 20px;
		color:#e60012;
	}
	.search-detail-left dl em {
		display: block;
		font-size: 16px;
		background:#e60012;
		color: #fff;
		text-align: center;
		line-height: 25px;
		position: absolute;
		left: 25px;
		top: 29px;
	width: 60px;

border-radius: 5px;


font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;




	}
	.search-parsing{
		display: flex;
		flex-direction: column;
	
	}
	.search-detail-left .search-parsing {
		
		

		padding: 20px 60px 20px 0;
		overflow: hidden;
	}
	.search-detail-left .search-parsing i {
		display: block;
		width: 130px;
		float: left;
		/* padding: 0 0 0 10px; */
		text-align: right;

font-size: 18px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #333333;
	}
	.search-detail-left .search-parsing span {
		display: block;
		margin-left: 110px;
	

font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #111111;
line-height: 30px;


	}
	.search-right-news {
		margin-top: 0;
		padding: 20px;
	}
	.search-right-bottom {
		padding: 20px 20px 1px 20px;
	}
	.search-right-bottom h3 {
		font-size: 16px;
		color: #333;
		overflow: hidden;
		padding-bottom: 20px;
	}
	.search-right-bottom a {
		padding: 0 10px;
		height: 40px;
		background: #ffe5cf;
		color: #ff9438;
		line-height: 40px;
		margin: 0 0 10px 0;
		overflow: hidden;
		display: inline-block;
		min-width: 50%;
	}
	.search-right-bottom a:hover {
		opacity: 0.7;
	}
	.parsing-red{display:inline-block; height: 15px; width: 5px; border-radius:  2px 2px 2px 2px;      background-color: red; }
	.search-right-bottom a:nth-child(2n + 1) {
		background: #dbf3ff;
		color:#e60012;
	}
	.search-right-book {
		border-top: 1px solid #ebebeb;
		border-bottom: 1px solid #ebebeb;
		padding: 20px;
	}
	.search-right-book h3 {
		font-size: 16px;
		color: #333;
		overflow: hidden;
		padding-bottom: 20px;
	}
	.el-carousel__item p {
		cursor: pointer;
	}
	
.answer-note {
    margin-top: 30px;
		width: 1200px;
box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
background-color: #FFFFFF;

}

.answer-note aside {
		margin:  0  auto;
    margin-top: 30px;
    
    border-radius: 4px;
    position: relative;
    padding: 10px;
		width: 1100px;
height: 150px;
    text-align: right;
		background-color:#F7F7F7  !important;
}
/deep/.el-textarea__inner{
	background-color: #F7F7F7  !important;
}
.answer-note textarea {
    border: none;
    resize: none;
    width: 1100px !important;
		height: 150px;
    outline: none;
    text-align: left;
    color: rgb(124, 21, 21);
    margin-bottom: 10px;
	
}
.note-list {
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;
		background: #FFFFFF;
}

.note-list-tit {
    display: flex;
    color: rgb(54, 53, 53);
    height: 50px;
}

.note-list-info {
    flex: 1;
    margin:  10px;
    overflow: hidden;
		display: flex;
		align-items: center;

}

.note-list-info div{
	width: 509px;
}
.note-list-in{	
text-align: center;
padding: 0 5px;	
display: inline-block;

font-size: 16px;
font-family: Microsoft YaHei;
line-height: 24px;
margin: 0 !important ;
font-weight: 400;
color: #111111;
}

.note-list-ins{	
display: inline-block;
width: 150px !important;
height: 24px;
font-size: 14px;
font-family: Arial;
font-weight: 400;
color: #111111;
line-height: 27px;
}



 .note-list-info span {
	
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
} 

.note-list-info p:last-child {
    font-size: 14px;
    color: #bbb;
}

.note-list .note-list-dete {
    padding: 0 10px;
    color: #ccc;
		width: 50px;
	 height: 24px;
   background: #EEEEEE;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f72525;

}
.note-list-dete{
margin-right: 10px;
}


.note-list .note-list-praise {
    padding: 0 10px 0 20px;
    color: #999;
    background: url('/images/an_10.png') left center no-repeat;
}

.note-list .note-list-active {
    background: url('/images/an_10_h.png') left center no-repeat;
    color: #ff9438 ;
}

.note-list button:hover {
    opacity: 0.7;
}

.note-list-text {
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 30px;


    color: #111111;
    margin-top: 15px;
}
.answer-note-list{
	margin-top: 30px;
}
</style>
